import React, { useMemo } from 'react';
import { Row, Col, Alert } from 'antd';
import type { SimulationDetail } from '../../store/simulation/types';
import { useSimulationReport, useReportFilterParams } from '../../hooks/simulation/useSimulationReport';
import { SimulationReportFilters } from './SimulationReportFilters';
import { SimulationChoropleth } from './SimulationChoropleth';

export interface SimulationChoroplethTabProps {
  simulation: SimulationDetail;
}

export const SimulationChoroplethTab = ({ simulation }: SimulationChoroplethTabProps) => {
  const isComplete = useMemo(() => simulation.simulationStatus === 'completed', [simulation]);
  const queryParams = useReportFilterParams();

  const { reportData, loading } = useSimulationReport(simulation, 'simulation-choropleth-report', queryParams);

  return (
    <Row gutter={16}>
      <Col span={24}>
        {!isComplete && (
          <Alert
            type={'warning'}
            showIcon={true}
            description={'The Time in Transit report will be available once the simulation has completed execution.'}
            message={'Simulation Incomplete'}
          />
        )}
        {isComplete && (
          <>
            <SimulationReportFilters simulation={simulation} />
            {/* remount on filter change so the imperatively-painted map re-renders (incl. clear-all) */}
            <SimulationChoropleth
              key={JSON.stringify(queryParams)}
              simulation={simulation}
              loading={loading}
              reportData={reportData}
            />
          </>
        )}
      </Col>
    </Row>
  );
};
